import { Component, createRef } from "@wordpress/element";

export default class AccordionBody extends Component {
	constructor() {
		super(...arguments);
		this.ref = createRef();
		this.state = {
			height: 1000,
		};
	}

	componentDidUpdate() {
		const height = this.ref.current.scrollHeight;
		if (height != this.state.height) {
			this.setState({ height });
		}
	}

	componentDidMount() {
		// hacky way to get around waiting for children to render...
		setTimeout(() => {
			const height = this.ref.current.scrollHeight;
			if (height != this.state.height) {
				this.setState({ height });
			}
		}, 1000);
	}

	render() {
		const {
			active,
			showBody = false,
			anchor = "accordion-anchor",
			idx = -1,
		} = this.props;
		return (
			<div
				ref={this.ref}
				id={`${anchor}-${idx}-body`}
				aria-labelledby={`${anchor}-${idx}-heading`}
				data-react="AccordionBody"
				className="overflow-hidden transition-all ease-in-out duration-300"
				style={{
					maxHeight: active || showBody ? this.state.height : 0,
				}}
			>
				<div className="p-4 text-lg space-y-2">{this.props.children}</div>
			</div>
		);
	}
}
